module.exports = __webpack_public_path__ + "img/20-800x800.9b5b9625.jpg";